module.exports = __webpack_public_path__ + "static/media/partner-logo4.c27ff691.png";